<template>
	<v-dialog
		v-model="filePreviewModal"
		:content-class="fileType"
		max-width="90%"
		transition="dialog-bottom-transition">
		<v-card v-if="file" color="grey">
			<v-toolbar
				:rounded="false"
				dark
				elevation="0"
				color="secondary">
				<v-toolbar-title>
					{{ file.name }}
				</v-toolbar-title>
				<v-spacer />
				<v-btn
					icon
					dark
					@click="filePreviewModal = false">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-card-text class="pa-0 file-preview">
				<div class="file-preview-container">
					<object v-if="file.type.includes('pdf')"
						:data="route('files.show', { file: file, stream: true })"
						:type="file.type">
						<embed :src="route('files.show', { file: file})" :type="file.mime" />
					</object>

					<img v-else-if="file.type.includes('image')"
						:src="route('files.show', { file: file, stream: true })"
						:alt="file.name"
						@click="filePreviewModal = false" />

					<iframe v-else-if="file.type === 'iframe' || file.type === 'text/plain'"
						:src="route('files.show', { file: file, stream: true })"
						:name="Date.now()" />

					<div v-else class="no-preview">
						<v-alert color="warning" outlined>Could not generate preview for this file type.</v-alert>
						<v-btn color="primary" :href="route('files.show', file)" target="_blank">Download File</v-btn>
					</div>
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>
<script>

export default {
	name: 'FileModal',
	props: {
		file: {
			type: Object,
			default: function () {
				return {}
			}
		}
	},
	data () {
		return {
			filePreviewModal: false
		}
	},
	computed: {
		fileType () {
			if (! this.file) {
				return null
			}

			if (this.file.type.includes('pdf')) {
				return 'file-pdf file-preview-dialog'
			}

			if (this.file.type.includes('image')) {
				return 'file-image file-preview-dialog'
			}

			if (this.file.type === 'iframe') {
				return 'file-iframe file-preview-dialog'
			}

			if (this.file.type === 'text/plain') {
				return 'file-text file-preview-dialog'
			}

			return 'file-other file-preview-dialog'
		}
	},
	watch: {
		'file.id' (fileId) {
			this.filePreviewModal = !!fileId
		},
		filePreviewModal (modalStatus) {
			if (! modalStatus) {
				this.$emit('close')
			}
		}
	}
}
</script>
